//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CartDisclaimer from '@/components/CartDisclaimer'
import {updateUrl} from "@/utils"

export default {
  name: 'AppCart',
  components: {CartDisclaimer},
  props: {
    moexUrl: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      columns: [
        { key: 'name', title: 'ИНФОРМАЦИОННЫЙ ПРОДУКТ' },
        { key: 'description', title: 'ОПИСАНИЕ' },
        { key: 'instrument', title: 'ИНСТРУМЕНТ' },
        { key: 'period', title: 'ПЕРИОД ДЕЙСТВИЯ' },
        { key: 'price', title: 'ЦЕНА' },
        { key: 'btn', title: '' },
      ],
      acceptTerms: false,
      proceed: false,
      terms: '',
      cartCount: 0,
      cartItems: [],
    }
  },

  computed: {
    cartModal: {
      get () { return this.value },
      set (v) { this.$emit('input', v) },
    },
    computedItems() {
      let total = 0
      const items = []
      if (this.cartItems) {
        this.cartItems.forEach((item) => {
          const name = item.Service && item.Service.Name
          const id = item.ID
          let description = ''
          let instrument = ''
          let period = ''
          total += parseFloat(item.Price)
          const price = `${item.Price} руб.`
          if (item.Data && item.Data[0]) {
            description = item.Data.reduce(
                (accumulator, currentValue) => `${accumulator + currentValue.NameMarket}, `,
                description,
            )
            description = description.slice(0, -2)
            period = `${item.Data[0].StartDate}<br>-<br>${item.Data[0].EndDate}`
            instrument = item.Data[0].Instrument || ''
          }
          items.push({
            id, name, description, instrument, period, price,
          })
        })
      }
      return {
        items,
        count: items.length,
        total: total.toFixed(2),
      }
    },
    modalTitle() {
      return this.proceed ? 'Условия предоставления данных' : 'Корзина услуг'
    },
  },

  mounted() {
    try {
      const cartItems = this.$cookies.get('moexMarketService')
      if (cartItems) {
        this.cartItems = JSON.parse(cartItems)
      }
    } catch (e) {
      this.cartItems = []
    }
    this.cartCount = this.cartItems.count
  },

  methods: {
    redirectToMoex() {
      window.location = `${this.moexUrl}/ru/orders`
    },
    getTerms() {
      this.proceed = true
    },
    makeOrder() {
      this.$router.push('/pages/lkp/my-orders')
      updateUrl(this.$i18n)
      this.cartModal = false
      this.proceed = false
      this.acceptTerms = false
    },
    removeCartItem(id) {
      const index = this.cartItems.findIndex((item) => item.ID === id)
      if (index > -1) {
        this.cartItems.splice(index, 1)
      }
      if (this.cartItems.length) {
        this.$cookies.set('moexMarketService', JSON.stringify(this.cartItems), 0, '/', 'moex.com' )
      } else {
        this.$cookies.remove('moexMarketService', '/', 'moex.com')
      }
    },
  },
}
